import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Machine } from '../machine/machine';
import { MachineService } from '../machine/machineService';
import { environment } from 'src/environments/environment';
import { LogEventService } from '../logevent/logeventservice';


@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private machines: Machine[];
    constructor(private http: HttpClient,
        private machineservice: MachineService, private logservice: LogEventService) { }
   
        //LOGIN ATTEMPT STORE USER AND JWT
    login(username: string, password: string) {
        return this.http.post<any>(`${environment.appURL}/auth/local`, { identifier: username, password: password })
            .pipe(map(user => {
                //console.log(user);
                //console.log(user.jwt);
                // login successful if there's a jwt token in the response
                if (user && user.jwt) {
                  //  console.log("BOTH ARE TRUE");
                    sessionStorage.setItem('currentUser', JSON.stringify(user));
                    environment.token = user.jwt

                    /* this.machineservice.getClientMachines(user.user.client.id).subscribe(res => {
                           this.machines = res;
                           sessionStorage.setItem('clientMachines', JSON.stringify(this.machines));
                           this.logservice.logEvent(user.user.id, "Login", { 
                               button: 'Login', page: 'Login Page', 
                           result : 'Success' });
                       });*/
                }
            }));
    }
   
    // LOG OUT AND DELETE SESSION STORAGE
    logout() { sessionStorage.removeItem('currentUser'); }

    // FORGOT PASS FEATURE
    forgotPass(email: string) {
        var resetUrl = environment.appURL + "/auth/forgot-password"
        var respUrl = environment.appURL + "/admin/plugins/users-permissions/auth/reset-password";
        var data = "email=" + email + "&url=" + respUrl;
        return this.http.post(resetUrl, data, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).subscribe(resp => { });
    }
}